var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6343 15.7657C13.3521 14.4835 11.3089 14.4803 9.55634 14.9458C8.93213 15.1117 8.27638 15.2 7.60001 15.2C3.40264 15.2 0 11.7974 0 7.60001C0 3.40264 3.40264 0 7.60001 0C11.7974 0 15.2 3.40264 15.2 7.60001C15.2 8.27638 15.1117 8.93213 14.9458 9.55634C14.4803 11.3089 14.4835 13.3521 15.7657 14.6343C16.0781 14.9467 16.0781 15.4533 15.7657 15.7657C15.4533 16.0781 14.9467 16.0781 14.6343 15.7657ZM1.6 7.60001C1.6 4.28629 4.28629 1.6 7.60001 1.6C10.9137 1.6 13.6 4.28629 13.6 7.60001C13.6 9.16365 13.0019 10.5877 12.0218 11.6556C11.9635 11.7192 11.8954 11.7733 11.8343 11.8343C11.7733 11.8954 11.7192 11.9635 11.6556 12.0218C10.5877 13.0019 9.16365 13.6 7.60001 13.6C4.28629 13.6 1.6 10.9137 1.6 7.60001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.89114e9516f4f1927e196d0533de41b8.svg";
export { ForwardRef as ReactComponent };